/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmUsageFiles } from "../../funcs/llmUsageFiles.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetFilesUsageRequest$inboundSchema,
};

export const tool$llmUsageFiles: ToolDefinition<typeof args> = {
  name: "llm-usage-files",
  description: `Get files usage

Retrieve bytes of files created per period from durable file creation events. This does not reflect current retained storage, buckets remain counted after file deletion, and grouped results collapse by requested output dimensions rather than one row per UserContext.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmUsageFiles(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
